import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';

import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { CardBody, CustomCard, CardTitle, LimitCharacterDiv } from './styles';

import handleLongText from '../../utils/handleLongText/handleLongText'
import handleCardColor from '../../utils/handleCardColor/handleCardColor';
import { ICardList } from '../../models/ICardList';
import { ButtonFavorite } from '../button-favorite';
import newIcon from "../../../assets/icons/new-icon.svg";
import { useHistory } from 'react-router-dom';

export const CardList: React.FC<ICardList> = ({ material, isMaterialView, isNew = false, children, onDetails, removeFavorite }) => {
    const { t: translation } = useTranslation();
    const [color, setColor] = useState<string>('black')
    const history = useHistory()


    useEffect(() => {
        setColor(handleCardColor(material.type_product))
    }, [material.type_product, material?.modalities, translation])

    const handleCardDetails = useCallback((e: any) => {
        if (onDetails) {
            onDetails({ material, tab: e.button })
        } else {
            switch (material.type_product) {
                case 'Item':
                    if (!e.button) {
                        history.push('/unity/' + material.id);
                    } else {
                        window.open('/unity/' + material.id)
                    }
                    break;
                case 'Theme':
                    if (!e.button) {
                        history.push('/themes/' + material.id);
                    } else {
                        window.open('/themes/' + material.id)
                    }
                    break;
                case 'Discipline':
                    if (!e.button) {
                        history.push('/disciplines/' + material.id);
                    } else {
                        window.open('/disciplines/' + material.id)
                    }
                    break;
                case 'Object':
                case 'Media':
                    if (!e.button) {
                        history.push('/objects/' + material.id);
                    } else {
                        window.open('/objects/' + material.id)
                    }
                    break;

                default:
                    break;
            }
        }

    }, [])

    return (
        <>
            <CustomCard style={{ borderLeft: 10 + `px solid ${color}` }}>
                <CardBody>
                    <Row>
                        <Col xs={11} md={11} lg={11} onMouseDown={(e) => handleCardDetails(e)}>
                            <Row>
                                <CardTitle>
                                    <h6>
                                        <OverlayTrigger placement="top" overlay={<Tooltip>{material.title}</Tooltip>}>
                                            <span>{handleLongText(material.title, 57)}</span>
                                        </OverlayTrigger>
                                    </h6>
                                </CardTitle>
                            </Row>

                            <Row>

                                {/* <CardMain> */}
                                <Row >

                                    <Col lg={3}>
                                        <LimitCharacterDiv><b>{translation('components.card-news.Code')}: </b> {material.code || translation('userAccount.uninformed')}</LimitCharacterDiv>
                                    </Col>

                                    <Col lg={3}>
                                        {material.type_product === 'Discipline' && (
                                            <LimitCharacterDiv><b>{translation('components.card-news.Workload')}: </b>{!!material?.workload ? material.workload + 'h' : translation('userAccount.uninformed')}</LimitCharacterDiv>
                                        )}
                                        {(material.type_product === 'Item' || material.type_product === 'Media') && material.discipline && (
                                            <LimitCharacterDiv> <b>{translation('components.card-news.Discipline')}: </b> {material.discipline || translation('userAccount.uninformed')}</LimitCharacterDiv>
                                        )}
                                        {material.type_product === 'Theme' && (
                                            <LimitCharacterDiv><b>{translation('components.card-news.Unit')}: </b> {material.item || translation('userAccount.uninformed')}</LimitCharacterDiv>
                                        )}
                                    </Col>
                                    {material.deadline && (
                                        <Col>

                                            <LimitCharacterDiv><b>{translation('components.card-news.Deadline')}: </b>{material.deadline > 1 ? '20 Dias' : 'Pronta Entrega'}</LimitCharacterDiv>

                                        </Col>
                                    )}
                                </Row>
                                {/* </CardMain> */}

                            </Row>

                        </Col>
                        <Col lg={1} className="utilsButtons" >

                            <ButtonFavorite material={material} isMaterialView={isMaterialView} removeFavorite={removeFavorite} />

                            {isNew &&
                                <img src={newIcon} height="20" alt='newIcon' style={{ marginTop: 5 }} />
                            }

                        </Col>
                    </Row>
                </CardBody>
            </CustomCard>
        </>
    );
}
